<template>
    <TileBar
        class="bg-info text-black"
        v-if="activeCustomer.firstname"
        :title="`${activeCustomer.firstname} cart`"
        :option-button="totalProductCount <= 0 ? `Add items` : `Clear cart`"
        @on-button="totalProductCount <= 0 ? onAddItems() : onClear()"
    >
        <q-dialog v-model="dialog" persistent>
            <DialogAlert
                :message="message"
                left-btn="Cancel"
                right-btn="Confirm"
                @leftClick="onleftClickDialog"
                @rightClick="onrightClickDialog"
            />
        </q-dialog>
    </TileBar>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DialogAlert from "@/ui/components/DialogAlert";
export default {
    name: "CartHeader",
    components: {
        DialogAlert,
        TileBar: () => import(`@/ui/components/TileBar`),
    },
    data() {
        return {
            dialog: false,
            message: null,
        };
    },
    computed: {
        ...mapState({
            activeCustomer: (state) => state["activeCustomer"]["customer"],
        }),
        ...mapGetters({
            totalProductCount: "cartData/totalProductCount",
        }),
    },
    methods: {
        onAddItems(){
            this.$router.push({
                name: "Home"
            });
        },
        onClear() {
            this.dialog = true;
            this.message = "Do you want to clear cart?";
        },
        onleftClickDialog() {
            this.dialog = false;
        },
        onrightClickDialog() {
            this.dialog = false;
            this.$store.dispatch("cart/clearBasket");
        },
    },
};
</script>
